// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*고객 정보 팝업*/
.SendOpinionPopup_send_opinion_pop__I5mSr{
    position: absolute;
    width: 500px;
    height: 430px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 17px 20px; box-sizing: border-box;
    z-index: 9999;
    display: block;
}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_tit__eU0Kn{
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    display: flex;
}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_tit__eU0Kn .SendOpinionPopup_close_btn__g-Wb9{margin-left: auto;cursor: pointer;}
.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_tit__eU0Kn .SendOpinionPopup_close_btn__g-Wb9 svg{position: relative; top: 2px;}
.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_tit__eU0Kn .SendOpinionPopup_title__kO8q4{color: black;}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_input__paDW1 {
    display:flex;
    border-bottom: 1px solid #EEEEEE;
    align-items: center;
}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_input__paDW1:last-child {
    align-items: flex-start;
}

.SendOpinionPopup_input__paDW1 p {
    width:70px;
    height:20px;
    font-size: 14px;
    color:#8B8686;
}

.SendOpinionPopup_input__paDW1 input {
    width:auto;
    height:30px;
}

.SendOpinionPopup_input__paDW1 textarea {
    width: 100%;
    height: 210px; /* 기존 input height의 4배 */
    font-size: 14px;
    resize: none;
    border:none;
    padding: 5px; /* padding을 추가하여 input과 동일한 UI */
    box-sizing: border-box; /* padding과 border를 포함한 width 계산 */
}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_icon_list__IoG7H {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom:10px;
}

.SendOpinionPopup_icon_list__IoG7H > div {
    gap:30px;
    margin: 10px 0;
}

.SendOpinionPopup_icon_list__IoG7H img {
    width:24px;
    height:24px;
}

.SendOpinionPopup_send_opinion_pop__I5mSr .SendOpinionPopup_send__rKUok {
    width: 100%;
    text-align: center;
}

.SendOpinionPopup_send__rKUok button {
    width: 110px;
    height: 30px;
    background: #51D7DF;
    color: #FFFFFF;
    font-size:16px;
    font-weight: 300;
    border-radius: 5px;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/SendOpinionPopup.module.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,gDAAgD;IACxD,kBAAkB,EAAkC,sBAAsB;IAC1E,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IAGnB,aAAa;AACjB;;AAEA,0GAAkC,iBAAiB,CAAC,eAAe,CAAC;AACpE,8GAAsC,kBAAkB,EAAE,QAAQ,CAAC;AACnE,sGAA8B,YAAY,CAAC;;AAE3C;IACI,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa,EAAE,wBAAwB;IACvC,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY,EAAE,gCAAgC;IAC9C,sBAAsB,EAAE,kCAAkC;AAC9D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["/*고객 정보 팝업*/\n.send_opinion_pop{\n    position: absolute;\n    width: 500px;\n    height: 430px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n    padding: 17px 20px; -webkit-box-sizing: border-box; box-sizing: border-box;\n    z-index: 9999;\n    display: block;\n}\n\n.send_opinion_pop .tit{\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.send_opinion_pop .tit .close_btn{margin-left: auto;cursor: pointer;}\n.send_opinion_pop .tit .close_btn svg{position: relative; top: 2px;}\n.send_opinion_pop .tit .title{color: black;}\n\n.send_opinion_pop .input {\n    display:flex;\n    border-bottom: 1px solid #EEEEEE;\n    align-items: center;\n}\n\n.send_opinion_pop .input:last-child {\n    align-items: flex-start;\n}\n\n.input p {\n    width:70px;\n    height:20px;\n    font-size: 14px;\n    color:#8B8686;\n}\n\n.input input {\n    width:auto;\n    height:30px;\n}\n\n.input textarea {\n    width: 100%;\n    height: 210px; /* 기존 input height의 4배 */\n    font-size: 14px;\n    resize: none;\n    border:none;\n    padding: 5px; /* padding을 추가하여 input과 동일한 UI */\n    box-sizing: border-box; /* padding과 border를 포함한 width 계산 */\n}\n\n.send_opinion_pop .icon_list {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom:10px;\n}\n\n.icon_list > div {\n    gap:30px;\n    margin: 10px 0;\n}\n\n.icon_list img {\n    width:24px;\n    height:24px;\n}\n\n.send_opinion_pop .send {\n    width: 100%;\n    text-align: center;\n}\n\n.send button {\n    width: 110px;\n    height: 30px;\n    background: #51D7DF;\n    color: #FFFFFF;\n    font-size:16px;\n    font-weight: 300;\n    border-radius: 5px;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"send_opinion_pop": `SendOpinionPopup_send_opinion_pop__I5mSr`,
	"tit": `SendOpinionPopup_tit__eU0Kn`,
	"close_btn": `SendOpinionPopup_close_btn__g-Wb9`,
	"title": `SendOpinionPopup_title__kO8q4`,
	"input": `SendOpinionPopup_input__paDW1`,
	"icon_list": `SendOpinionPopup_icon_list__IoG7H`,
	"send": `SendOpinionPopup_send__rKUok`
};
export default ___CSS_LOADER_EXPORT___;
